// API configuration
// In production, use relative URLs (same origin)
// In development, use the backend server URL
const getApiBaseUrl = (): string => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    // Use environment variable if set, otherwise default to localhost:3005
    return process.env.REACT_APP_API_URL || 'http://localhost:3005';
  }
  // In production, use relative URLs (same origin as the React app)
  return '';
};

export const API_BASE_URL = getApiBaseUrl();
